import { useMutation } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';
import { useGanttSimulationTaskStateStore } from '../../components/organisms/ProductionPlans/Gantt/store';

type FreezeTaskMutationInput = {
  taskId: number;
  type: 'task' | 'batch';
  freeze: boolean;
};

export const freezeTaskMutationKey = (simulationId: number, taskId: number) => [
  'gantt-simulation',
  'freeze-task',
  simulationId,
  taskId,
];

export const useGanttSimulationFreezeTask = (simulationId: number, taskId: number) => {
  const api = useGraphneAPI();
  const addFrozenTaskIds = useGanttSimulationTaskStateStore((state) => state.addFrozenTaskIds);
  const removeFrozenTaskIds = useGanttSimulationTaskStateStore((state) => state.removeFrozenTaskIds);

  return useMutation({
    mutationKey: freezeTaskMutationKey(simulationId, taskId),
    mutationFn: (data: FreezeTaskMutationInput) => {
      const payload = {
        simulationId: simulationId.toString(),
        p1: data.taskId.toString(),
      };

      if (data.type === 'task') {
        if (data.freeze) {
          return api.postGraphneSimulationSimulationidTasksP1Freeze(payload);
        } else {
          return api.postGraphneSimulationSimulationidTasksP1Unfreeze(payload);
        }
      } else {
        if (data.freeze) {
          return api.postGraphneSimulationSimulationidBatchesP1Freeze(payload);
        } else {
          return api.postGraphneSimulationSimulationidBatchesP1Unfreeze(payload);
        }
      }
    },
    onSuccess: (data, { freeze }) => {
      if (freeze) {
        addFrozenTaskIds(data);
      } else {
        removeFrozenTaskIds(data);
      }
    },
  });
};
